






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Course from '../../../api/v2/models/course'
import User from '../../models/user'
import { ROUTER_NAME } from '../../router'
import api from '../../../api/v2/api'

@Component({
  components: {}
})
export default class CourseButton extends Vue {
  @Prop({ required: true }) course: Course
  @Prop({ required: true }) user: User

  title: string = '今すぐ受講する'
  private buttonState: 'Apply' | 'Buy' | 'BuyPremium' | 'Continue' = 'Apply'

  async created() {
    try {
      const enrollment = await api.enrollment.show({
        user_id: this.user.id,
        course_id: this.course.id
      })
      
      if (this.user.hasActiveSubscription && this.user.premiumCourseIds.indexOf(this.course.id) != -1){
        this.buttonState = 'Apply'
        this.title = '今すぐ受講する'
        if (enrollment && enrollment.id) {
          this.buttonState = 'Continue'
          this.title = '受講コースへ移動する（すでに受講済みです）'
        }
        return
      }

      if (enrollment && enrollment.id) {
        this.buttonState = 'Continue'
        this.title = '受講コースへ移動する（すでに受講済みです）'
        return
      }

      if (this.course.typeIs == 'product') {
        this.buttonState = 'Buy'
        this.title = '今すぐ購入する'
        return
      }

      this.buttonState = 'Apply'
      if (this.course.typeIs == 'text') {
        this.title = '今すぐ閲覧する'
        return
      }
      if (this.course.typeIs == 'free') {
        this.title = '今すぐ受講する【無料】'
        return
      }
      if (this.course.typeIs == 'premium') {
        this.buttonState = 'BuyPremium'
        this.title = 'プレミアムサービスを見る'
        return
      }
      this.title = '今すぐ受講する'
    } catch(e) {
    }
  }

  async buttonAction() {
    switch(this.buttonState) {
      case 'Apply':
        try {
          await api.enrollment.create({
            user_id: this.user.id,
            course_id: this.course.id
          })
          return this.$router.push({
            name: ROUTER_NAME.MY_COURSE_DETAIL,
            params: {
              examId: this.course.id.toString()
            }
          })
        } catch(e) {
        }
        return
      case 'Buy':
        return this.$router.push({
          name: ROUTER_NAME.COURSE_PURCHASE,
          params: {
            examId: this.course.id.toString()
          }
        })
      case 'BuyPremium':
        return this.$router.push({
          name: ROUTER_NAME.PREMIUM_SERVICE
        })
      case 'Continue':
        return this.$router.push({
          name: ROUTER_NAME.MY_COURSE_DETAIL,
          params: {
            examId: this.course.id.toString()
          }
        })
    }
  }
}
